import { range, isNil } from 'lodash';

const points =
  '25.96 0 19.83 18.86 0 18.86 16.04 30.52 9.92 49.38 25.96 37.72 42.01 49.38 35.88 30.52 51.92 18.86 32.09 18.86 25.96 0';

const Star = props => (
  <div {...props}>
    <svg
      width="20"
      height="20"
      className="float-left"
      viewBox="0 0 51.92 49.38"
      role="img"
    >
      <polygon points={points} />
    </svg>
  </div>
);

const starFillClass = (stars, i) => {
  if (isNil(stars)) {
    return 'unfilled';
  }
  const fillClass = stars >= 4 ? 'positive' : 'negative';

  return i + 1 <= stars ? fillClass : 'unfilled';
};

const Stars = ({ id, stars, otherClassNames = '' }) => (
  <div className={`stars-wrapper ${otherClassNames}`}>
    {range(5).map(i => (
      <Star
        key={`stars-${id}-${i}`}
        className={`star ${starFillClass(stars, i)}`}
      />
    ))}
  </div>
);

export default Stars;
